var _excluded = ["children", "className", "description", "id", "placement"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled, { css } from 'styled-components';
import { DATA_ATTRS, TAB_PLACEMENTS } from "./constants.js";
import { isChildElement } from "./utils.js";
var StyledTabGroupContainer = styled.div.withConfig({
  componentId: "CL__sc-14ne0vb-0"
})(["--border-height:calc(var(--spacing-1) / 2);display:inline-flex;gap:0 var(--spacing-3);max-width:100%;overflow:auto;.tabGroup-tab{appearance:none;background-color:unset;border:unset;color:var(--text-color-dim);display:inline-block;cursor:pointer;margin:0;position:relative;text-align:center;text-decoration:none;text-rendering:optimizeLegibility;transition:color var(--hover-transition);vertical-align:top;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;", " &:disabled{opacity:0.5;pointer-events:none;}&:focus{outline:unset;}&:hover,&:focus-visible,&[", "='true']{color:var(--text-color);}strong{visibility:hidden;}span{left:50%;position:absolute;transform:translateX(-50%);vertical-align:top;}&[", "='true'] span{font-weight:var(--body-text-bold-font-weight);}&::before,&::after{background-color:var(--border-color);border-radius:var(--border-radius-round);bottom:0;content:'';height:var(--border-height);left:0;opacity:0;position:absolute;transition:opacity var(--hover-transition);width:100%;}&:focus-visible::before{background-color:var(--text-color);opacity:1;}&:not([", "='true'],:active):hover::before{opacity:1;}&:not([", "='true']):active::before{opacity:0.5;}&[", "='true']::after{background-image:linear-gradient(90deg,var(--purple-4),var(--blue-5));opacity:1;}}"], _ref => {
  var {
    $placement
  } = _ref;
  return $placement === TAB_PLACEMENTS.PAGE ? css(["font:var(--body-text-medium);padding:var(--spacing-1) 0 var(--spacing-2);"]) : css(["font:var(--body-text-small);padding:var(--spacing-1) 0;"]);
}, DATA_ATTRS.SELECTED, DATA_ATTRS.SELECTED, DATA_ATTRS.SELECTED, DATA_ATTRS.SELECTED, DATA_ATTRS.SELECTED);
var TabGroup = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
      children,
      className,
      description,
      id,
      placement = TAB_PLACEMENTS.CONTAINER
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledTabGroupContainer, _extends({
    $placement: placement,
    "aria-label": description,
    as: placement === TAB_PLACEMENTS.PAGE ? 'nav' : 'div',
    className: "".concat(className || '', " ").concat(placement, "-tabGroup"),
    id: id,
    ref: ref,
    role: placement === TAB_PLACEMENTS.PAGE ? '' : 'tablist'
  }, props), React.Children.map(children, (child, index) => {
    if (!isChildElement(child)) return null;
    var {
      children,
      className,
      disabled,
      [DATA_ATTRS.FOR]: dataFor,
      [DATA_ATTRS.SELECTED]: dataSelected,
      [DATA_ATTRS.TAB_PANEL]: dataTabpanel,
      [DATA_ATTRS.TIP]: dataTip = false
    } = child.props;
    return disabled ? /*#__PURE__*/React.createElement("div", {
      "data-for": dataFor,
      "data-tip": dataTip
    }, /*#__PURE__*/React.createElement("button", {
      disabled: true,
      className: "".concat(className !== null && className !== void 0 ? className : '', " tabGroup-tab"),
      type: "button"
    }, children)) : (/*#__PURE__*/React.cloneElement(child, {
      'aria-controls': dataTabpanel,
      'aria-selected': !!dataSelected,
      children: [/*#__PURE__*/React.createElement("span", {
        key: "tab-child-".concat(children)
      }, children), /*#__PURE__*/React.createElement("strong", {
        key: "tab-hidden-child-".concat(children)
      }, children)],
      className: "".concat(className !== null && className !== void 0 ? className : '', " tabGroup-tab"),
      id: dataTabpanel ? "".concat(dataTabpanel, "-tab") : "".concat(id, "-tab-").concat(index),
      role: placement === TAB_PLACEMENTS.PAGE ? undefined : 'tab',
      tabIndex: 0
    }));
  }));
});
export default TabGroup;